// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivacyPolicy_container__2X6lY","heading":"PrivacyPolicy_heading__3-5yr","content":"PrivacyPolicy_content__1JyXE"};